import { render, staticRenderFns } from "./Takeaway.vue?vue&type=template&id=4029a80c&scoped=true&"
import script from "./Takeaway.vue?vue&type=script&lang=js&"
export * from "./Takeaway.vue?vue&type=script&lang=js&"
import style0 from "./Takeaway.vue?vue&type=style&index=0&id=4029a80c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4029a80c",
  null
  
)

export default component.exports